<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.patrolLogs") }}</h3>
            </div>
            <div class="card-body">
                <PatrolLogTable
                    :patrolLogs="patrolLogs"
                    :success="getPatrolLogs"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import PatrolLogTable from '@/components/dashboard/PatrolLogTable.vue';

export default {
    components: {
        Icon,
        PatrolLogTable,
    },
    data() {
        return {
            patrolLogs: [],
        }
    },
    created() {
        this.getPatrolLogs();
    },
    methods: {
        getPatrolLogs() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/patrol-logs`)
            .then(res => {
                this.patrolLogs = res.data;
            })
            .catch(error => {
                console.error("Error loading patrol logs.", error);
            })
        },
    },
}
</script>